import { Option } from "./dropdown/dropdown-option-model";

export class Language {
  public static readonly en = 'en';
  public static readonly th = 'th';
}

export class LanguageContent {
  en: String;
  th: String;
}

export class Page {
  public static readonly REDIRECT = 'redirect';
  public static readonly LEVEL_D = 'levelD';
  public static readonly LEVEL_C = 'levelC';
  public static readonly CHECKOUT = 'checkout';
  public static readonly CREATE_ORDER = 'createorder';
  public static readonly HOME = 'home';
}

export class LandingAction {
  public static readonly RESET = 'reset';
  public static readonly VERIFY = 'verify';
}

export class SuggestionCategory {
  public static readonly DESTINATION = 'destination';
  public static readonly POINT_OF_INTEREST = 'pointofinterest';
  public static readonly NEAR_BY = 'nearby';
  public static readonly PRODUCT = 'product';
}

export class DefaultValue {
  public static readonly DISTANCE = 30000;
  public static readonly CURRENCY = {
    currencyId: 1,
    currencyCode: "THB",
    currencyNameTh: "บาท ไทย",
    currencyNameEn: "Thai Baht",
    exchangeRate: 1.0
  };
}

export class STATE {
  public static readonly VERIFY_ACCOUNT = 'VERIFY_ACCOUNT';
  public static readonly VERIFY_EMAIL = 'VERIFY_EMAIL';
  public static readonly LOGIN = 'LOGIN';
  public static readonly CREATE_ACCOUNT = 'CREATE_ACCOUNT';
  public static readonly CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
  public static readonly REGISTER_MEMBER = 'REGISTER_MEMBER';
  public static readonly JOIN_US = 'JOIN_US';
  public static readonly RESET_PASSWORD = 'RESET_PASSWORD';
  public static readonly CHECK_DOMAIN = 'CHECK_DOMAIN';
  public static readonly TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS';
  public static readonly TERMS_AND_CONDITIONS_OPEN = 'TERMS_AND_CONDITIONS_OPEN';
  public static readonly TERMS_AND_CONDITIONS_OPEN_VIEW = 'TERMS_AND_CONDITIONS_OPEN_VIEW';
  public static readonly FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
  public static readonly FORGOT_PASSWORD = 'FORGOT_PASSWORD';
  public static readonly DIALOG_MESSAGE = 'DIALOG_MESSAGE';
};

export class FeatureType {
  public static readonly ALLOW_LIMIT_BUDGET = 'allow_limit_budget';
  public static readonly ALLOW_LIMIT_ROOM = 'allow_limit_room';
  public static readonly ALLOW_LIMIT_CHILD = 'allow_limit_child';
  public static readonly ALLOW_SUPERVISOR_APPROVAL = 'allow_supervisor_approval';
  public static readonly ALLOW_EDIT_PROFILE = 'allow_edit_profile';
  public static readonly ALLOW_CHANGE_PASSWORD = 'allow_change_password';
  public static readonly ALLOW_CREDIT_TERMS = 'allow_credit_terms';
  public static readonly ALLOW_OVERLAP_BOOKING_PERIOD = 'allow_overlap_booking_period';
  public static readonly ALLOW_SEND_EMAIL_APPROVE = 'allow_send_email_approve';
  public static readonly ALLOW_SEND_EMAIL_NOTIFICATION = 'allow_send_email_notification';
  public static readonly ALLOW_BOOK_ACROSS_MONTHS = 'allow_book_across_months';
  public static readonly ALLOW_MULTI_PAYMENT = 'allow_multi_payment';
  public static readonly ALLOW_MULTI_PAYMENT_CORPORATE_FLEET = 'allow_multi_payment_corporate_fleet';
  public static readonly ALLOW_SHARE_BUDGET = 'allow_share_budget';
  public static readonly ALLOW_BOOK_FLIGHT = 'allow_book_flight';
  public static readonly ALLOW_RENT_CAR_CREDIT_TERMS = 'allow_rent_car_credit_terms';
  public static readonly ALLOW_RENT_CAR_OTHER_PAYMENTS = 'allow_rent_car_other_payments';
  public static readonly ALLOW_DISPLAY_PERMISSION_MENU = 'allow_display_permission_menu';
  public static readonly ALLOW_BOOK_WORK_PURPOSE = 'allow_book_work_purpose';
  public static readonly ENABLE_CH2_BOOKER_EMAIL = 'enable_ch2_booker_email';
  public static readonly ALLOW_CORPORATE_FLEET = 'allow_corporate_fleet';
  public static readonly ALLOW_BOOK_FOR_TRAVELLER = 'allow_book_for_traveller';
  public static readonly CONFIG_NOTIFY_TERMS_CONDITIONS_AFTER_LOGIN = 'config_notify_terms_conditions_after_login';
  public static readonly ENABLE_PIN = 'enable_pin';
  public static readonly ENABLE_PRE_APPROVAL = 'enable_pre_approval';

  public static readonly checkout3CostCenter = 'CHECKOUT_3_COST_CENTER';
  public static readonly checkout3BillingAddress = 'CHECKOUT_3_BILLING_ADDRESS';
  public static readonly checkout3InternalOrder = 'CHECKOUT_3_INTERNAL_ORDER';
  public static readonly checkout3DocumentAttach = 'CHECKOUT_3_DOCUMENT_ATTACHED';
}
export class CompanyFeatureType {
  public static readonly checkout3CostCenter = 'CHECKOUT_3_COST_CENTER';
  public static readonly checkout3BillingAddress = 'CHECKOUT_3_BILLING_ADDRESS';
  public static readonly checkout3InternalOrder = 'CHECKOUT_3_INTERNAL_ORDER';
  public static readonly checkout3DocumentAttach = 'CHECKOUT_3_DOCUMENT_ATTACHED';
}

export class CompanyFeatureConfigType {
  public static readonly CONFIG_CHECKOUT_3 = 'config_checkout_3';
  public static readonly CONFIG_NOTIFY_TERMS_CONDITIONS_AFTER_LOGIN = 'config_notify_terms_conditions_after_login';
}

export class PurposeType {
  public static readonly work = 'work';
  public static readonly leisure = 'leisure';
}

export class ActionType {
  public static readonly autoSave = 'AUTO_SAVE';
  public static readonly normalSave = 'NORMAL_SAVE';
}

export class PaymentMethodType {
  public static readonly creditCard = 'creditCard';
  public static readonly creditTerm = 'creditTerm';
  public static readonly trueMoneyWallet = 'trueMoneyWallet';
  public static readonly fleetCard = 'fleetCard';
  public static readonly personalFleet = 'personalFleet';
  public static readonly corporateFleet = 'corporateFleet';
  public static readonly qrCode = 'qrCode';
  public static readonly eWallet = 'eWallet';
  public static readonly imBanking = 'imBanking';
  public static readonly payAtCounter = 'payAtCounter';
}


export class PaymentChannelType {
  public static readonly CREDIT_CARD = 'credit-card';
  public static readonly CREDIT_TERMS = 'credit-terms';
  public static readonly MULTI_PAYMENT = 'multi-payment';
  public static readonly TRUE_MONEY = 'true-money';
  public static readonly FLEET_CARD = 'fleet-card';
  public static readonly PERSONAL_FLEET = 'personal-fleet';
  public static readonly CORPORATE_FLEET = 'corporate-fleet';
  public static readonly QR_CODE = 'qr-code';
  public static readonly E_WALLET = 'e-wallet';
  public static readonly IM_BANKING = 'im-banking';
  public static readonly PAY_AT_COUNTER = 'pay-at-counter';
}

export class PaymentMethodDetailType {
  public static readonly CREDIT_CARD = 'credit_card';
  public static readonly CREDIT_TERMS = 'credit_terms';
  public static readonly TRUE_MONEY = 'true_money';
  public static readonly CORPORATE_FLEET = 'corporate_fleet';
  public static readonly PERSONAL_FLEET = 'personal_fleet';
  public static readonly DEBIT_CARD = 'debit_card';
  public static readonly MULTI_PAYMENT = 'multi_payment';
  public static readonly QR_CODE = 'qr_code';
  public static readonly E_WALLET = 'e_wallet';
  public static readonly IM_BANKING = 'im_banking';
  public static readonly PAY_AT_COUNTER = 'pay_at_counter';
}

export class PaymentErrorCodeType {
  public static readonly INVALID_CARD_NUMBER = 'Invalid Card Number';
  public static readonly INSUFFICIENT_FUNDS = 'Insufficient Funds';
  public static readonly UNKNOWN = 'Unknown';
}

export class BookerType {
  public static readonly MAIN_BOOKER = 'MAIN_BOOKER';
  public static readonly SHARED_BOOKER = 'SHARED_BOOKER';
}

export class PaymentMethodUpperCaseType {
  public static readonly creditCard = 'CREDIT_CARD';
  public static readonly creditTerms = 'CREDIT_TERMS';
}

export class BookingStatusType {
  public static readonly ON_PROCESS = 'on_process';
  public static readonly BOOKING_SUCCESS = 'booking_success';
  public static readonly WAITING_FOR_APPROVE = 'waiting_for_approve';
  public static readonly PAYMENT_SUCCESS = 'payment_success';
  public static readonly APPROVE = 'approve';
  public static readonly CANCEL = 'cancel';
  public static readonly CANCEL_BY_MAIN_BOOKER = 'cancel_by_main_booker';
  public static readonly CANCEL_BY_CO_BOOKER = 'cancel_by_co_booker';
  public static readonly REJECT_BY_SUPERVISOR = 'reject_by_main_supervisor';
  public static readonly REJECT_BY_CO_SUPERVISOR = 'reject_by_co_supervisor';
  public static readonly REJECT = 'reject';
  public static readonly PAYMENT_FAIL = 'payment_fail';
  public static readonly BOOKING_FAIL = 'booking_fail';
  public static readonly DEPART = 'depart';
  public static readonly CANNOT_CREATE_BOOKING = 'cannot_create_booking';
  public static readonly TIMEOUT = 'timeout';
}

export class PaymentType {
  public static readonly SHARE_BUDGET_BY_ADMIN = 'share_budget_by_admin';
  public static readonly SHARE_BUDGET_BY_ADMIN_MULTI_PAYMENT = 'share_budget_by_admin_multi_payment';
}

export class OrderStatus {
  public static readonly CREATE = 'create';
  public static readonly PAID = 'paid';
  public static readonly BOOK = 'book';
  public static readonly FAIL = 'fail';
  public static readonly NO = 'no';
  public static readonly CANCEL = 'cancel';
  public static readonly SUCCESS = 'success';
  public static readonly PENDING = 'pending';
}

export class FeatureInternalOrderType {
  public static readonly label = 'label';
  public static readonly placeholder = 'placeholder';
}

export class FeatureProperty {
  public static readonly required = 'required';
  public static readonly diaplay = 'display';
  public static readonly placeholder = 'placeholder';
  public static readonly label = 'label';
  public static readonly type = 'type';
  public static readonly notify = 'notify';
}

export class UserExistCode {
  public static readonly userExisted = '2001';
  public static readonly userNotVerified = '2002';
  public static readonly userNotExisted = '2003';
}

export class UserExistType {
  public static readonly userExisted = 'User Exist';
  public static readonly userNotVerified = 'User Not Exist';
  public static readonly userNotExisted = 'User Not Verified';
}

export class ResponseStatusType {
  public static readonly success = 'SUCCESS';
  public static readonly failure = 'FAILURE';
  public static readonly processing = 'PROCESSING';
}

export class FilterSortType {
  public static readonly filter = 'filter';
  public static readonly sort = 'sort';
}

export class FilterByType {
  public static readonly all = 'all';
  public static readonly upComing = 'up-coming';
  public static readonly departed = 'departed';
  public static readonly cancelled = 'cancelled';
  public static readonly failed = 'failed';
  public static readonly checkin = 'checkin';
  public static readonly waiting = 'waiting';
  public static readonly approved = 'approved';
  public static readonly rejected = 'rejected';
}

export class SortByType {
  public static readonly bookingDate = 'booking-date';
  public static readonly checkinDate = 'check-in-date';
  public static readonly paymentDate = 'payment-date';
}

export class OrderByType {
  public static readonly ascending = 'asc';
  public static readonly descending = 'desc';
}

export class HttpMethod {
  public static readonly GET = 'GET';
  public static readonly POST = 'POST';
  public static readonly PUT = 'PUT';
  public static readonly DELETE = 'DELETE';
}

export class EncryptionType {
  public static readonly TRUE_CUSTOM = 'true_custom';
  public static readonly BASE64 = 'base64';
}

export class ApprovalActionState {
  public static readonly APPROVED = 'APRROVED';
  public static readonly REJECT_WITH_FEE = 'REJECT_WITH_FEE';
  public static readonly REJECT_FREE = 'REJECT_FREE';
  public static readonly REJECTED = 'REJECTED';
  public static readonly UNABLE_APPROVAL = 'UNABLE_APPROVAL';
}

export class ApprovalActionErrorCode {
  public static readonly CANCELED = '4201';
  public static readonly APPROVED = '4202';
  public static readonly REJECTED = '4203';
  public static readonly INVALID_BOOKING_ID_OR_OTP = '4531';
  public static readonly INVALID_BOOKING_APPROVAL = '4901';
  public static readonly APPROVAL_NOT_FOUND = '4533';
}

export class ApprovalStatusType {
  public static readonly PENDING = 'pending';
  public static readonly APPROVE = 'approve';
  public static readonly REJECT = 'reject';
  public static readonly BOOKER_CANCELLED = 'booker_cancelled';
  public static readonly LAST_MINUTE = 'last_minute';
  public static readonly NO_ACTION = 'no_action';
  public static readonly UNABLE_TO_ACTION = 'unable_to_action'
  public static readonly UNKNOWN = 'unknown';
}

export class CancelBookingType {
  public static readonly CANCEL = 'cancel';
  public static readonly REJECT = 'reject';
}

export class ApprovalUpdateByType {
  public static readonly SUPERVISOR = 'supervisor';
  public static readonly CHECKINDATE = 'check-in date';
  public static readonly CRON = 'cron';
}

export class PromotionErrorCode {
  public static readonly REQUIRE = '4803';
  public static readonly FULLY_USED = '4804';
  public static readonly USED = '4802';
  public static readonly INVALID = '4801';
}

export class ConditionDisplayType {
  public static readonly ONE_BUTTON = 'oneButton';
  public static readonly TWO_BUTTON = 'twoButton';
  public static readonly ONE_BUTTON_DIVIDER = 'oneButtonDivider';
  public static readonly TABLE = 'table';
}

export class MiceServiceTypes {
  public static readonly TH = ['จัดงานประชุมสัมมนา',
    'จัดกิจกรรมพัฒนาบุคคลากร',
    'ทริปเดินทางในประเทศ และต่างประเทศ',
    'จัดงานเลี้ยงและงานพิธีต่างๆ',
    'จัดกิจกรรมสาธารณประโยชน์เพื่อสังคม',
    'บริการเช่าเครื่องบินส่วนตัว',
    'บริการรถเช่า',
    'จองตั๋วเครื่องบินและขอวีซ่าทั่วโลก'
  ];
  public static readonly EN = ['Seminar Management',
    'Team Building & Rally',
    'Group Tour & Incentive Group',
    'Staff Party & Merit-making Ceremony',
    'CSR Activity',
    'Private Jet',
    'Car Rental',
    'Ticket & Visa Service'];
}

export class PaymentGateway {
  public static readonly TCTP_GATEWAY_ID = 1;
  public static readonly TCTP_TMN = 3;
}

export class OriginalBookingStatusType {
  public static readonly CREATE = 'create';
  public static readonly PENDING = 'pending';
  public static readonly SUCCESS = 'success';
  public static readonly FAIL = 'fail';
  public static readonly CANCEL = 'cancel';
  public static readonly CANCEL_BOOKING = 'cancel_booking';
  public static readonly CANCEL_CREDIT = 'cancel_credit';
  public static readonly CANCEL_NON_CREDIT = 'cancel_non_credit';
  public static readonly CANCEL_MULTI_PAYMENT = 'cancel_multi_payment';
  public static readonly UNKNOWN = 'unknown';
}

export class CLIENT_ID {
  public static readonly ASCENDTRAVEL = 1;
  public static readonly B2C = 3;
}

export class FieldType {
  public static readonly DROPDOWN = 'dropdown';
  public static readonly FREE_TEXT = 'free_text';
  public static readonly ATTACHMENT = 'attachment';
  public static readonly TAX_ADDRESS_BY_API = 'tax_address_by_api';
}

export class InternalOrderType {
  public static readonly DROPDOWN = 'dropdown';
  public static readonly FREE_TEXT = 'free_text';
}

export class UncommonThingsIconModel {
  titleTH: String;
  titleEN: String;
  path: String;

  constructor(titleTH: String, titleEN: String, path: String) {
    this.titleTH = titleTH;
    this.titleEN = titleEN;
    this.path = path;
  }
}
export class UncommonThingsIconMapping {
  public static readonly uncommonThingsIconMapping = [
    new UncommonThingsIconModel('เจอสิ่งลี้ลับ', 'Mysterious things', 'assets/images/icons/monster-ghost.png'),
    new UncommonThingsIconModel('เจอตุ๊กแก', 'Gecko', 'assets/images/icons/monster-gecko.png'),
    new UncommonThingsIconModel('เจอหนู', 'Rat', 'assets/images/icons/monster-rat.png'),
    new UncommonThingsIconModel('เจอจิ้งจก', 'Lizard', 'assets/images/icons/monster-lizard.png'),
    new UncommonThingsIconModel('เจอแมลงสาบ', 'Cockroach', 'assets/images/icons/monster-cockroach.png')
  ];

  public static getIcon(title: String): String {
    const iconMapping = UncommonThingsIconMapping.uncommonThingsIconMapping.find(item => {
      return title == item.titleTH || title == item.titleEN;
    });
    return iconMapping ? iconMapping.path : '';
  }
}

export class OfferType {
  public static readonly ROOM_ONLY = 'Room Only';
  public static readonly BREAKFAST = 'Breakfast';
  public static readonly ALL_INCLUSIVE = 'All Inclusive';
  public static readonly FULL_BOARD = 'Full Board';
  public static readonly HALF_BOARD = 'Half Board';
}

export class DocumentType {
  public static readonly VOUCHER = 'voucher';
  public static readonly TAX_INVOICE = 'tax_invoice';
  public static readonly TAX_INVOICE_CANCEL = 'tax_invoice_cancel';
  public static readonly CREDIT_NOTE = 'credit_note';
}

export class CheckOut3DataType {
  public static readonly CREDIT_TERMS_INFO = 'CREDIT_TERMS_INFO';
  public static readonly CREDIT_TERMS_TAX_INFO = 'CREDIT_TERMS_TAX_INFO';
  public static readonly CREDIT_CARD_INFO = 'CREDIT_CARD_INFO';
  public static readonly CREDIT_CARD_TAX_INFO = 'CREDIT_CARD_TAX_INFO';
  public static readonly PAYMENT_INFO = 'PAYMENT_INFO';
  public static readonly TRUE_MONEY_WALLET = 'TRUE_MONEY_WALLET';
  public static readonly TRUE_MONEY_WALLET_TAX_INFO = 'TRUE_MONEY_WALLET_TAX_INFO';
  public static readonly QR_CODE = 'QR_CODE';
  public static readonly QR_CODE_TAX_INFO = 'QR_CODE_TAX_INFO';
  public static readonly E_WALLET = 'E_WALLET';
  public static readonly E_WALLET_TAX_INFO = 'E_WALLET_TAX_INFO';
  public static readonly IM_BANKING = 'IM_BANKING';
  public static readonly IM_BANKING_TAX_INFO = 'IM_BANKING_TAX_INFO';
  public static readonly PAY_AT_COUNTER = 'PAY_AT_COUNTER';
  public static readonly PAY_AT_COUNTER_TAX_INFO = 'PAY_AT_COUNTER_TAX_INFO';
}

export class PaymentChannelStatus {
  // multi-payment, credit terms must alway be PAID
  public static readonly PAID = 'PAID';
  // only credit card can be PAY_LATER
  public static readonly PAY_LATER = 'PAY_LATER';
  // payment fail
  public static readonly PAY_FAIL = 'PAY_FAIL';
  // booking fail or cancel before payment date
  public static readonly UNPAID = 'UNPAID';
}

export class RefundType {
  public static readonly NON_REFUND = 'NON_REFUND';
  public static readonly PARTIAL_REFUND = 'PARTIAL_REFUND';
  public static readonly FULL_REFUND = 'FULL_REFUND';
}

export class CallingCodeOption {
  public static readonly DEFAULT = new Option('Thailand (+66)', 'TH', 'flags/th.png', '+66');
}

export class SSO {
  public static readonly RESPONSE_TPYE = 'code';
  public static readonly SCOPE = 'openid';
  public static readonly CODE_CHALLENGE_METHOD = 'S256';
  public static readonly CLIENT_ID = '1';
  public static readonly GRANT_TYPE = 'authorization_code';
  public static readonly INVALID_USER_CONSENT_CODE = '4005';
}

export class HotelListRequestDefault {
  public static readonly CURRENCY_ID = 1;
  public static readonly DISTANCE = 10000;
  public static readonly PRICE_RANGE_MIN = 0;
  public static readonly PRICE_RANGE_MAX = 50000;
  public static readonly ITEM_PER_PAGE = 40;
}

export class TermAndPrivacyType {
  public static readonly TERM_OF_USE = 'termOfUse';
  public static readonly PRAVACY_NOTICE = 'pravacyNotice';
}

export class PaymentStatus {
  public static readonly AUTHORIZE = 'authorize';
  public static readonly FAIL = 'fail';
  public static readonly PENDING = 'pending';
  public static readonly SUCCESS = 'success';
  public static readonly CANCEL_VOID = 'void';
  public static readonly CANCEL_REFUND = 'refund';
  public static readonly CANCEL_NON_REFUND = 'non_refund';
  public static readonly ON_PROCESS = 'on_process';
  public static readonly CANCEL = 'cancel';
  public static readonly REFUND_FAILED = 'refund_failed';
  public static readonly REFUND_ON_PROCESS = 'refund_on_process';
}

export class LocalStorage {
  public static readonly PROMOTION = 'promotion'
}

export class PatternFormat {
  public static readonly PASSWORD_REGEXR = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,16}$/;
  public static readonly VALID_CHARACTER = /^([A-Za-z\d@$!%*#?&]+)$/;
  public static readonly AT_LEAST_ONE_UPPERCASE = /(?=.*?[A-Z])/;
  public static readonly AT_LEAST_ONE_LOWERCASE = /(?=.*?[a-z])/;
  public static readonly AT_LEAST_ONE_NUMERIC = /(?=.*?[0-9])/;
}

export const BlacklistPIN = ['000000', '111111', '222222', '333333', '444444', '555555', '666666', '777777', '888888', '999999', '123456']

export class DiscountType {
  public static readonly PROMOTION_CODE = 'promotion_code';
}

export class RequestType {
  public static readonly NORMAL = 'normal';
  public static readonly SHARE_BUDGET = 'share_budget';
  public static readonly BOOK_FOR_TRAVELLER = 'book_for_traveller';
}



// WEBPACK FOOTER //
// ./src/app/model/constant.ts